module.exports = __webpack_public_path__ + "img/1.715f522b.jpg";